import { ReportsContract } from '@terra/shared-contracts-reports';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const reportsClient = createTerraOrpcClient({
  contract: ReportsContract,
  serviceName: SERVICE_NAME,
});
